// Employer Reference Number (ERN / Employer PAYE Reference) validation. HMRC format: a 3-digit tax
// office number, a forward slash, then a 1-10 character alphanumeric employer reference (e.g.
// 123/AB45678) — so up to 14 characters including the slash
const ERN = /^\d{3}\/[A-Za-z0-9]{1,10}$/;

export const isValidErn = (value: unknown): boolean => {
    if (value === null || value === undefined) return true;
    const v = String(value).trim();
    // Blank passes — the field is no longer required (the ERN can be supplied within 14 days).
    if (v === '') return true;
    // If entered, it must be a valid ERN of at least 8 characters (max 14, a 10-char reference).
    return v.length >= 8 && ERN.test(v);
};
